export const DAILY_PRICELIST_ID = 29;
export const MONTHLY_PRICELIST_TYPE_ID = 3;
